import React, { Component } from "react";
import Navbar from "./components/Navbar";
import "./App.css";
import Home from "./components/__pages/Home";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Article from "./components/__pages/Articles/Article";
import styled from "styled-components";
import ArticleEditor from "./components/__pages/Articles/ArticleEditor";
import FantasyArticles from "./components/__pages/Articles/FantasyArticles";
import NFLStatEngine from "./components/__pages/__tools/__rtools/NFLStatEngine";
import CFBStatEngine from "./components/__pages/__tools/__rtools/CFBStatEngine";
import LiveTournamentTool from "./components/__pages/__tools/__rtools/__pga/LiveTournamentTool";
import PGAModel from "./components/__pages/__tools/__rtools/__pga/PGAModel";
import PGASweatTool from "./components/__pages/__tools/__rtools/__pga/PGASweatTool";
import Store from "./components/__pages/Store";
import Slack from "./components/__pages/Slack";
import BettingArticles from "./components/__pages/Articles/BettingArticles";
import Memberships from "./components/__pages/Memberships";
import Register from "./components/__pages/Memberships/Register";
import SignInForm from "./components/__pages/SignIn/SignInForm";
import { AuthProvider } from "./AuthContext";
import ContentSubRoute from "./PrivateRoutes/ContentSubRoute";
import ContentWriterRoute from "./PrivateRoutes/ContentWriterRoute";
import Logout from "./components/__pages/Logout";
import PGAResearchCenter from "./components/__pages/__tools/__rtools/__pga/PGAResearchCenter";
import Footer from "./components/Footer";
import Account from "./components/__pages/Account";
import Avatars from "./components/__pages/Account/Avatars";
import TermsAndConditions from "./components/__pages/TermsAndConditions";
import PrivacyPolicy from "./components/__pages/PrivacyPolicy";
import Podcasts from "./components/__pages/PodcastsPage";
import ForgotPassword from "./components/__pages/ForgotPassword";
import GreenMachinePage from "./components/__pages/__tools/GreenMachinePage";
import ContentSchedule from "./components/__pages/ContentSchedule";
import PageNotFound from "./components/__pages/PageNotFound";

import { createBrowserHistory } from "history";
import UploadPodcastPage from "./components/__pages/UploadPodcastPage";
import ResetPassword from "./components/__pages/ResetPassword";
import GreenMachineAdmin from "./components/__pages/__tools/GreenMachinePage/GreenMachineAdmin";
import ErrorBoundary from "./ErrorBoundary";
import Affiliates from "./components/__pages/Affiliates";
import NFLStatEnginePage from "./components/__pages/__tools/__nfl/NFLStatEnginePage";
import NFLRedzoneAdvantagePage from "./components/__pages/__tools/__nfl/NFLRedzoneAdvantagePage";
import NFLScoutingReportPage from "./components/__pages/__tools/__nfl/NFLScoutingReportPage";
import NFLMatchupAdvantagePage from "./components/__pages/__tools/__nfl/NFLMatchupAdvantagePage";
import NFLProjections from "./components/__pages/__tools/__nfl/NFLProjectionsPage";
import NFLProjectionsAdmin from "./components/__pages/__tools/__nfl/NFLProjectionsPage/NFLProjectionsAdmin";
import DraftArticlesPage from "./components/__pages/Articles/DraftArticlesPage";
import NFLOddsReportTable from "./components/__pages/__tools/__nfl/NFLOddsReportPage/NFLOddsReportTable";
import NFLOddsReportPage from "./components/__pages/__tools/__nfl/NFLOddsReportPage";
import NascarProjectionsPage from "./components/__pages/__tools/__nascar/NascarProjectionsPage";
import InvalidSlackEmailsPage from "./components/__pages/__admin/InvalidSlackEmailsPage";
import LiveTournamentToolPage from "./components/__pages/__tools/__pga/LiveTournamentToolPage";
import PGAModelBuilderPage from "./components/__pages/__tools/__pga/PGAModelBuilderPage";
import PGASweatToolPage from "./components/__pages/__tools/__pga/PGASweatToolPage";
import PGAResearchCenterPage from "./components/__pages/__tools/__pga/PGAResearchCenterPage";
import PGAProfilePage from "./components/__pages/__tools/__pga/PGAProfilePage";
//import PGAModelBuilderPage from "./components/__pages/__tools/__pga/PGAModelBuilderPage";

const history = createBrowserHistory();

const MainContent = styled.div`
  position: relative;
  margin-top: 72px;
  padding-bottom: 0;
  display: block;

  min-height: calc(100vh - 72px);
`;

class App extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <AuthProvider>
        <Router history={history}>
          <Navbar />
          <MainContent>
            <ErrorBoundary>
              <Switch>
                <Route path="/" exact component={Home} />

                <Route path="/admin/slack" component={InvalidSlackEmailsPage} />

                <ContentSubRoute
                  path="/fantasy/:sport"
                  component={FantasyArticles}
                />
                <ContentSubRoute path="/fantasy" component={FantasyArticles} />

                <Route path="/betting/:sport" component={BettingArticles} />
                <Route path="/betting" component={BettingArticles} />

                <Route path="/affiliates" component={Affiliates} />

                <ContentWriterRoute
                  path="/article/edit/:articleId"
                  component={ArticleEditor}
                />
                <Route path="/article/create" component={ArticleEditor} />
                <Route path="/article/drafts" component={DraftArticlesPage} />
                <ContentSubRoute
                  path="/article/:articleId/:articleSlug"
                  exact
                  component={Article}
                />
                <ContentSubRoute
                  path="/article/:year/:month/:day/:articleSlug"
                  exact
                  component={Article}
                />

                <Route
                  path="/tools/green-machine/admin"
                  component={GreenMachineAdmin}
                />
                <Route
                  path="/tools/green-machine"
                  component={GreenMachinePage}
                />

                <Route path="/tools/nfl-engine" component={NFLStatEnginePage} />

                <Route
                  path="/tools/matchup-advantage"
                  component={NFLMatchupAdvantagePage}
                />

                <Route
                  path="/tools/redzone-advantage"
                  component={NFLRedzoneAdvantagePage}
                />

                <Route
                  path="/tools/scouting-report"
                  component={NFLScoutingReportPage}
                />

                <Route
                  path="/tools/nfl/projections"
                  component={NFLProjections}
                  exact
                />

                <Route
                  path="/tools/nfl/projections/admin"
                  component={NFLProjectionsAdmin}
                />

                <Route path="/tools/nfl/odds" component={NFLOddsReportPage} />

                <Route
                  path="/tools/nascar/projections"
                  component={NascarProjectionsPage}
                />

                <Route path="/tools/cfb-engine" component={CFBStatEngine} />
                <Route
                  path="/tools/pga-live-tournament-tool"
                  component={LiveTournamentToolPage}
                />
                <Route path="/tools/pga-model/old" component={PGAModel} />
                <Route
                  path="/tools/pga-model"
                  component={PGAModelBuilderPage}
                />
                <Route
                  path="/tools/pga-sweat-tool"
                  component={PGASweatToolPage}
                />
                <Route
                  path="/tools/pga-research"
                  component={PGAResearchCenterPage}
                />
                <Route
                  path="/tools/pga-profile/:playerId"
                  component={PGAProfilePage}
                />

                <Route path="/podcasts/upload" component={UploadPodcastPage} />
                <Route path="/podcasts" component={Podcasts} />

                <Route path="/slack" component={Slack} />

                <Route path="/login" component={SignInForm} />

                <Route path="/memberships" exact component={Memberships} />
                <Route path="/register" exact component={Register} />
                <Route
                  path="/memberships/register/:priceId"
                  component={Register}
                />

                <Route
                  path="/resetpassword/:userId/:resetToken"
                  component={ResetPassword}
                />
                <Route path="/content-schedule" component={ContentSchedule} />
                <Route path="/avatars" component={Avatars} />
                <Route path="/account" component={Account} />
                <Route path="/forgot-password" component={ForgotPassword} />
                <Route
                  path="/terms-and-conditions"
                  component={TermsAndConditions}
                />
                <Route path="/privacy" component={PrivacyPolicy} />
                <Route path="/logout" component={Logout} />

                <Route
                  path="*"
                  render={() => <PageNotFound errorCode={404} />}
                />
              </Switch>
            </ErrorBoundary>
          </MainContent>
          <Footer />
        </Router>
      </AuthProvider>
    );
  }
}

export default App;
